/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelGetAPIDetailRequest,
  ModelGetAPIDetailResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ApiDetail<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description get api detail
   *
   * @tags api
   * @name ApiDetailCreate
   * @summary get api detail
   * @request POST:/apiDetail
   */
  apiDetailCreate = (
    request: ModelGetAPIDetailRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelGetAPIDetailResponse, any>({
      path: `/apiDetail`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
